import { render, staticRenderFns } from "./CollectWriteItemAddLayout.vue?vue&type=template&id=45fd6fe0&scoped=true"
import script from "./CollectWriteItemAddLayout.vue?vue&type=script&lang=js"
export * from "./CollectWriteItemAddLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45fd6fe0",
  null
  
)

export default component.exports